import { axiosRequestHelper, RequestHelperResult } from './endpoint-helpers';

export const acceptEula = (): Promise<RequestHelperResult<undefined>> => axiosRequestHelper('POST', '/api/eula/accept');
